export const CommonConstant = {
  // MQ url
  // aws
  MQ_URL: 'wss://b-2e123f1c-3fa4-42d2-98f7-8a54b1a46821-1.mq.ap-southeast-2.amazonaws.com:61619',

  // 本地
  // MQ_URL: 'ws://127.0.0.1:61614?maximumConnections=1000&amp;wireFormat.maxFrameSize=104857600',
  // MQ 登录名
  MQ_LOGIN: 'mymqtest',
  // MQ_LOGIN: 'admin',
  // MQ 登录密码
  MQ_PASSCODE: 'mymqtest1234',
  // MQ_PASSCODE: 'admin',
  // MQ 队列名
  MQ_DESTINATION: '/Topics/aaa',
  // stomp客户端
  MQ_STOMP_CLIENT: 'v11.stomp',
  // MQ Time Out
  MQ_TIME_OUT: 5 * 60 * 1000
}



// WEBPACK FOOTER //
// ./src/utils/CommonConstant.js